import virtualizationReducer from "./reducers";

export {
  fetchVMsListStart,
  fetchTaskStatusListStart,
  createVMTaskStart,
  controlVMStart,
  deleteVMStart,
  fetchVIRTRecoveryPointsStart,
  updateVMConfigurationsStart,
  rebuildVMStart,
  fetchVirtUserInfoStart,
  closeSSEConnection,
  logoutVirtInstances,
  logoutSingleVirtInstances,
  handleRPCConsoleAccessStart,
  handleRPCBootProgressStart,
  disableRPCconnectionstatus
} from "./operations";
export default virtualizationReducer;
